import React from 'react'
import { SvgIcon } from '@mui/material'

export const ApproveIcon = props => (
  <SvgIcon
    viewBox="0 0 18 18"
    sx={{ width: '18px', height: '18px' }}
    {...props}
  >
    <path
      d="m11.04 7.1-3.22 3.22-1.24-1.24a.75.75 0 1 0-1.05 1.06l1.76 1.77a.75.75 0 0 0 1.06 0l3.75-3.75a.75.75 0 1 0-1.06-1.07ZM9 2a7.5 7.5 0 1 0 0 15A7.5 7.5 0 0 0 9 2Zm0 13.5a6 6 0 1 1 0-12 6 6 0 0 1 0 12Z"
      fill="inherit"
    />
  </SvgIcon>
)
